import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { AiOutlineDownload } from "react-icons/ai";
import html2pdf from "html2pdf.js";
import { RiStarSLine } from "react-icons/ri";
import { FaCheckCircle } from "react-icons/fa";

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id") || "";
  const customer_auto_id = sessionStorage.getItem("accessToken");
  const [themeColor, setThemeColor] = useState("#ffffff");
  const [showOrder, setShowOrder] = useState(false);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showRateModal, setShowRateModal] = useState(null);
  const [rating, setRating] = useState(0);
  const [reviewReason, setReviewReason] = useState("");
  const [customReason, setCustomReason] = useState("");
  const [reviewImage, setReviewImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [webFont, setWebFont] = useState("");

  //  NEW: user profile for invoice user block
  const [profileData, setProfileData] = useState(null);
  const [updatedData, setUpdatedData] = useState(null);
  const [custImageBase64Map, setCustImageBase64Map] = useState({});



  //  NEW: app logo for invoice
  const appLogo = sessionStorage.getItem("appLogo") || "";

  //  NEW: base64 logo for PDF (fix image not showing)
  const [invoiceLogo, setInvoiceLogo] = useState("");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }


  const parsePipeArray = (value = "") =>
    value.split("|").map(v => v.trim());

  const toNumber = (val) => {
    const n = parseFloat(val);
    return isNaN(n) ? 0 : n;
  };

  const thStyle = {
    padding: "10px",
    textAlign: "left",
    border: "1px solid #e5e7eb",
    width: "40%",
  };

  const thCenterStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #e5e7eb",
    width: "10%",
  };

  const thRightStyle = {
    padding: "10px",
    textAlign: "right",
    border: "1px solid #e5e7eb",
    width: "20%",
  };

  const tdStyle = {
    padding: "10px",
    border: "1px solid #e5e7eb",
  };

  const tdCenterStyle = {
    padding: "10px",
    textAlign: "center",
    border: "1px solid #e5e7eb",
  };

  const tdRightStyle = {
    padding: "10px",
    textAlign: "right",
    border: "1px solid #e5e7eb",
  };


  //  NEW: Convert image URL -> base64 so html2canvas can print it
  const convertImageToBase64 = async (imageUrl) => {
    try {
      const response = await fetch(imageUrl, { mode: "cors" });
      const blob = await response.blob();
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Failed to convert image to base64:", error);
      return "";
    }
  };

  const calcGSTAmount = (finalPrice, taxPercent, qty, includingTax) => {
    if (!taxPercent) return 0;

    if (includingTax === "Yes") {
      const base = finalPrice / (1 + taxPercent / 100);
      return (finalPrice - base) * qty;
    }

    return (finalPrice * taxPercent * qty) / 100;
  };




  //  NEW: prepare logo base64 once (fix invoice logo missing)
  useEffect(() => {
    const setLogoForInvoice = async () => {
      if (!appLogo) return;

      //  IMPORTANT: Use your exact base URL
      const logoUrl = `https://geobull.in/GrobizEcommerceSuperAdmin/images/admin_logo/${appLogo}`;

      const base64 = await convertImageToBase64(logoUrl);
      if (base64) setInvoiceLogo(base64);
    };

    setLogoForInvoice();
  }, [appLogo]);

  //  NEW: Fetch profile for invoice
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const userAutoId = sessionStorage.getItem("accessToken");
        if (!userAutoId) return;

        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/get_user_profile`,
          { user_auto_id: userAutoId },
          { headers: { "Content-Type": "application/json" } }
        );

        console.log("API Response:", response.data);

        if (response.data.status === "1" && response.data.data) {
          setProfileData(response.data.data);
          setUpdatedData(response.data.data);
        } else {
          console.error("Invalid response format:", response.data);
          setProfileData(null);
        }
      } catch (error) {
        console.error("API Error:", error);
        setProfileData(null);
      }
    };

    fetchProfile();
  }, []);

  const showTaxColumn = orderDetails?.product_details?.some(
    (p) => p.including_tax === "No"
  );


  //  PROFESSIONAL PDF INVOICE (Like your sample)
  const handleDownloadPdf = () => {
    const element = document.getElementById("invoice-section");
    if (!element) return;

    const images = element.querySelectorAll("img");
    const promises = Array.from(images).map((img) =>
      img.complete
        ? Promise.resolve()
        : new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        })
    );

    Promise.all(promises).then(() => {
      const opt = {
        margin: [0.25, 0.25, 0.25, 0.25],
        filename: `${orderDetails?.order_id || "invoice"}.pdf`,
        image: { type: "jpeg", quality: 1 },
        html2canvas: {
          scale: 2,
          useCORS: true,
          backgroundColor: "#ffffff",
          scrollX: 0,
          scrollY: 0,
          windowWidth: element.scrollWidth,
        },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
        pagebreak: { mode: ["css", "legacy"] },
      };

      html2pdf().set(opt).from(element).save();
    });
  };

  useEffect(() => {
    fetchOrders();
  }, [page]);

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_single_vendor_order_customer`,
        {
          admin_auto_id,
          limit: 10,
          page_number: page,
          customer_auto_id,
        }
      );
      if (response.data.status === 1) {
        const newOrders = response.data.data;
        const totalPages = response.data.total_pages;
        setOrders(newOrders);
        setTotalPages(totalPages);
        setHasMore(page < totalPages);
      } else {
        setOrders([]);
        setHasMore(false);
      }
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  };



  const fetchOrderDetails = async (orderId, userId) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/get_order_details`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            admin_auto_id,
            customer_auto_id,
            user_auto_id: userId,
            order_id: orderId,
          }),
        }
      );
      const data = await response.json();
      if (data.status === 1) {
        setOrderDetails(data.data[0]);
      }
    } catch (error) { }
  };

  const handleViewDetails = (orderId, userId) => {
    const isSameOrder = showOrder === orderId;
    setShowOrder(isSameOrder ? null : orderId);
    if (!isSameOrder) {
      fetchOrderDetails(orderId, userId);
    }
  };

  const handleRateOrder = (orderId, productAutoId, productOrderAutoId) => {
    setShowRateModal({
      order_id: orderId,
      product_auto_id: productAutoId,
      product_order_auto_id: productOrderAutoId,
    });
    setRating(0);
    setReviewReason("");
    setCustomReason("");
    setReviewImage(null);
    setImagePreview(null);
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/jpg", "image/png"];
      if (!validTypes.includes(file.type)) {
        Swal.fire("Error", "Please upload a JPEG or PNG image.", "error");
        e.target.value = null;
        return;
      }
      const maxSize = 5 * 1024 * 1024;
      if (file.size > maxSize) {
        Swal.fire("Error", "Image size must be less than 5MB.", "error");
        e.target.value = null;
        return;
      }
      setReviewImage(file);
      setImagePreview(URL.createObjectURL(file));
    }
  };

  const handleRemoveImage = () => {
    setReviewImage(null);
    setImagePreview(null);
    document.getElementById("review-image-input").value = null;
  };

  const handleSubmitRating = async (
    orderId,
    productAutoId,
    productOrderAutoId
  ) => {
    if (!rating) {
      Swal.fire("Error", "Please select a rating", "error");
      return;
    }
    if (!reviewReason && !customReason) {
      Swal.fire("Error", "Please select or enter a review reason", "error");
      return;
    }
    const finalReason = reviewReason === "Other" ? customReason : reviewReason;

    try {
      const formData = new FormData();
      formData.append("admin_auto_id", admin_auto_id);
      formData.append("customer_auto_id", customer_auto_id);
      formData.append("product_order_auto_id", productOrderAutoId);
      formData.append("product_auto_id", productAutoId);
      formData.append("app_type_id", app_type_id);
      formData.append("rating", rating);
      formData.append("review", finalReason);
      formData.append("finishing", "");
      formData.append("product_quality", "");
      formData.append("pricing", "");
      formData.append("size_fitting", "");
      if (reviewImage) formData.append("review_image", reviewImage);

      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/Store-Product-Rating-Review`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );

      if (response.data.status === 1) {
        Swal.fire("Success!", "Your rating has been submitted.", "success");
        setShowRateModal(null);
        setReviewImage(null);
        setImagePreview(null);
      } else {
        Swal.fire(
          "Error",
          response.data.msg || "Failed to submit rating",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "Something went wrong while submitting the rating.",
        "error"
      );
    }
  };

  const handleCancelOrder = async (order_auto_id) => {
    const { value: reason } = await Swal.fire({
      title: "Cancel Order?",
      input: "textarea",
      inputLabel: "Reason for cancellation",
      inputPlaceholder: "Type your reason here...",
      showCancelButton: true,
      confirmButtonText: "Yes, cancel it",
      cancelButtonText: "No, keep it",
    });

    if (reason) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/cancel_order_single_vendor_customer`,
          { admin_auto_id, customer_auto_id, order_auto_id, reason }
        );

        if (response.data.status === 1) {
          Swal.fire("Cancelled!", "The order has been cancelled.", "success");
          fetchOrders();
        } else {
          Swal.fire(
            "Error",
            response.data.message || "Failed to cancel order",
            "error"
          );
        }
      } catch (error) {
        Swal.fire(
          "Error",
          "Something went wrong while cancelling the order.",
          "error"
        );
      }
    }
  };

  return (
    <div className={`p-6 ${webFont}`}>
      <div className="flex items-center justify-between px-6 py-2 mb-6 bg-white border border-gray-200 rounded-lg shadow-sm">
        <h2 className="text-xl font-bold">My Orders</h2>
      </div>

      <div className="grid gap-5">
        {loading ? (
          <p className="text-center text-gray-500">Loading...</p>
        ) : orders.length === 0 ? (
          <p className="text-center text-gray-500">No data available</p>
        ) : (
          orders.map((order) => (

            <div
              key={order.order_id}
              className="flex flex-col gap-4 p-3 m-3 bg-white border-b rounded-lg shadow-sm"
            >
              <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center md:gap-0">
                <div className="flex items-start gap-4">
                  <img
                    src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${order.product_image.split("|")[0]}`}
                    alt={order.order_id}
                    className="object-cover w-20 h-20 border border-gray-200 rounded-md"
                  />
                  <div className="grid">
                    <p className="font-semibold text-black">{order.order_id}</p>
                    <p className="flex flex-wrap items-center gap-1 text-xs text-gray-500">
                      <span
                        className={`px-2 py-0.5 rounded-lg text-xs ${order.order_status === "Cancelled"
                          ? "bg-red-100 text-red-600"
                          : "bg-green-100 text-green-600"
                          }`}
                      >
                        {order.order_status}
                      </span>
                      <span>• Placed on {order.order_date}</span>
                    </p>
                  </div>
                </div>

                <div className="flex gap-2 mt-2 md:mt-0">
                  <button
                    onClick={() =>
                      handleViewDetails(
                        order.order_id,
                        order.added_by_id.split("|")[0]
                      )
                    }
                    className="px-4 py-2 text-sm font-medium transition border rounded-lg"
                    style={{
                      color: themeColor,
                      borderColor: lightenHexColor(themeColor, 0.2),
                    }}
                    onMouseEnter={(e) => {
                      const lightenColor = lightenHexColor(themeColor, 0.2);
                      e.currentTarget.style.backgroundColor = lightenColor;
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor = "#ffffff";
                    }}
                  >
                    {showOrder === order.order_id
                      ? "Hide Details"
                      : "View Details"}
                  </button>

                  <button
                    onClick={() => {
                      if (
                        order.order_status !== "Completed" &&
                        order.order_status !== "Cancelled"
                      ) {
                        handleCancelOrder(order.order_id);
                      }
                    }}
                    disabled={
                      order.order_status === "Completed" ||
                      order.order_status === "Cancelled"
                    }
                    className={`px-4 py-2 text-sm font-medium border rounded-lg transition ${order.order_status === "Completed" ||
                      order.order_status === "Cancelled"
                      ? "text-gray-400 border-gray-300 bg-gray-100 cursor-not-allowed"
                      : "text-red-600 border-red-400 hover:bg-red-50"
                      }`}
                  >
                    Cancel
                  </button>
                </div>
              </div>

              {showOrder === order.order_id && orderDetails && (
                <>
                  <div className="w-full max-w-2xl p-4 mx-auto mt-5 bg-white border rounded-lg shadow-sm">
                    <div className="flex flex-col mb-4 sm:flex-row sm:items-center sm:justify-between">
                      <h2 className="text-2xl font-semibold text-gray-800">
                        Order Summary
                      </h2>
                      <button
                        onClick={handleDownloadPdf}
                        className="flex items-center mt-2 text-sm sm:mt-0"
                        style={{ color: themeColor }}
                      >
                        Download invoice{" "}
                        <AiOutlineDownload className="ml-2 text-xl" />
                      </button>
                    </div>

                    <div className="pb-4 mb-6 border-b">
                      <h3 className="mb-2 text-lg font-semibold text-gray-700">
                        Items in this Order
                      </h3>
                      {Array.isArray(orderDetails.product_details) &&
                        orderDetails.product_details.map((item, idx) => (
                          <div
                            key={idx}
                            className="flex items-start justify-between py-2 text-sm text-gray-700"
                          >
                            <div className="flex items-start gap-3">
                              <img
                                src={
                                  item.product_image
                                    ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_image}`
                                    : "https://via.placeholder.com/48"
                                }
                                alt={item.product_name}
                                className="object-cover border rounded-md w-14 h-14"
                              />
                              <div>
                                <p className="font-medium">
                                  {item.product_name}
                                </p>


                                <div className="flex items-start gap-2">
                                  <p className="flex items-center gap-2 text-xs text-gray-500">
                                    Qty: {item.quantity}

                                    {item.cust_image && item.cust_image !== "" && (
                                      <>
                                        <FaCheckCircle className="text-xs text-green-600" />
                                        <span>Customized</span>
                                      </>
                                    )}
                                  </p>


                                  {order.order_status === "Completed" && (
                                    <span
                                      onClick={() =>
                                        handleRateOrder(
                                          order.order_id,
                                          item.product_auto_id,
                                          item.product_order_auto_id
                                        )
                                      }
                                      className="text-sm text-blue-600 underline cursor-pointer hover:text-blue-800"
                                    >
                                      Rate This Product
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                            <span className="font-semibold whitespace-nowrap">
                              {item.product_final_price} Rs
                            </span>
                          </div>
                        ))}
                    </div>

                    <div className="pb-4 mb-6 border-b">
                      <h3 className="mb-2 text-lg font-semibold text-gray-700">
                        Bill Details
                      </h3>
                      <div className="space-y-2 text-sm text-gray-700">
                        <div className="flex justify-between">
                          <span>MRP</span>
                          <span>{orderDetails.total_price} Rs</span>
                        </div>

                        <div className="flex justify-between">
                          <span>Delivery Charges</span>
                          <span>
                            {orderDetails.pincode_delivery_charge || "Free"}
                          </span>
                        </div>

                        {toNumber(orderDetails.delivery_slot_price) > 0 && (
                          <div className="flex justify-between">
                            <span>Delivery Slot Price</span>
                            <span>{orderDetails.delivery_slot_price} Rs</span>
                          </div>
                        )}

                        {toNumber(orderDetails.handling_fee) > 0 && (
                          <div className="flex justify-between">
                            <span>Handling Fee</span>
                            <span>{orderDetails.handling_fee} Rs</span>
                          </div>
                        )}

                        {toNumber(orderDetails.donation_fee) > 0 && (
                          <div className="flex justify-between">
                            <span>Donation Fee</span>
                            <span>{orderDetails.donation_fee} Rs</span>
                          </div>
                        )}

                        {toNumber(orderDetails.giftwrap_fee) > 0 && (
                          <div className="flex justify-between">
                            <span>Gift Wrap Fee</span>
                            <span>{orderDetails.giftwrap_fee} Rs</span>
                          </div>
                        )}

                        {toNumber(orderDetails.tip_amount) > 0 && (
                          <div className="flex justify-between">
                            <span>Tip Amount</span>
                            <span>{orderDetails.tip_amount} Rs</span>
                          </div>
                        )}

                        {toNumber(orderDetails.rain_surge_charge) > 0 && (
                          <div className="flex justify-between">
                            <span>Rain Surge Charge</span>
                            <span>{orderDetails.rain_surge_charge} Rs</span>
                          </div>
                        )}

                        <div className="flex justify-between pt-2 font-bold text-black border-t">
                          <span>Total</span>
                          <span>{orderDetails.total_paid_price} Rs</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/*  HIDDEN CLEAN PROFESSIONAL INVOICE LIKE SAMPLE */}
                  <div className="hidden">
                    <div
                      id="invoice-section"
                      style={{
                        width: "100%",
                        maxWidth: "7.7in",
                        padding: "0.35in",
                        margin: "0 auto",
                        backgroundColor: "#ffffff",
                        boxSizing: "border-box",
                        overflow: "hidden",
                        fontFamily: "Arial, sans-serif",
                        color: "#111827",
                      }}
                    >
                      {/* HEADER */}
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: "12px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "10px",
                            alignItems: "center",
                          }}
                        >
                          {/*  FIXED: use base64 logo so it prints in PDF */}
                          {invoiceLogo ? (
                            <img
                              src={invoiceLogo}
                              alt="logo"
                              style={{
                                width: "70px",
                                height: "70px",
                                objectFit: "contain",
                                borderRadius: "8px",
                              }}
                            />
                          ) : null}

                          <div>
                            <h1
                              style={{
                                margin: 0,
                                fontSize: "20px",
                                fontWeight: "800",
                              }}
                            >
                              Invoice Details
                            </h1>
                            <p
                              style={{
                                margin: "6px 0 0 0",
                                fontSize: "12px",
                                color: "#6b7280",
                              }}
                            >
                              Order ID: <b>{orderDetails.order_id}</b>
                            </p>
                          </div>
                        </div>

                        <div
                          style={{
                            textAlign: "right",
                            fontSize: "12px",
                            color: "#111827",
                          }}
                        >
                          <p style={{ margin: 0 }}>
                            <b>Order Date:</b> {orderDetails.order_date}
                          </p>
                          <p style={{ margin: "6px 0 0 0" }}>
                            <b>Order Time:</b> {orderDetails.order_time}
                          </p>
                          <p style={{ margin: "6px 0 0 0" }}>
                            <b>Payment Mode:</b> {orderDetails.payment_mode}
                          </p>
                          <p style={{ margin: "6px 0 0 0" }}>
                            <b>Delivery Date:</b>{" "}
                            {orderDetails.schedule_date || ""}
                          </p>
                        </div>
                      </div>

                      <hr
                        style={{
                          margin: "14px 0",
                          border: "0.5px solid #e5e7eb",
                        }}
                      />

                      {/* USER + ADDRESS SECTION */}
                      <div style={{ display: "flex", gap: "18px" }}>
                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              fontWeight: "800",
                            }}
                          >
                            User
                          </h3>
                          <p
                            style={{
                              margin: "8px 0 0 0",
                              fontSize: "12px",
                              lineHeight: "18px",
                            }}
                          >
                            {profileData?.name || ""}
                            <br />
                            {profileData?.email_id || ""}
                            <br />
                            {profileData?.country_code || "IN-91"}{" "}
                            {profileData?.mobile_number || orderDetails.mobile_no}
                          </p>

                          <h3
                            style={{
                              margin: "12px 0 0 0",
                              fontSize: "13px",
                              fontWeight: "800",
                            }}
                          >
                            Billing Address
                          </h3>
                          <p
                            style={{
                              margin: "8px 0 0 0",
                              fontSize: "12px",
                              lineHeight: "18px",
                            }}
                          >
                            {profileData.address},{profileData.city}
                            <br />
                            {/* {orderDetails.state},{orderDetails.country}- */}
                            {profileData.used_pincode}
                            <br />
                            Contact No: {profileData.mobile_number}
                          </p>

                          {orderDetails.gst_number ? (
                            <p style={{ margin: "8px 0 0 0", fontSize: "12px" }}>
                              <b>GST Number:</b> {orderDetails.gst_number}
                            </p>
                          ) : null}
                        </div>

                        <div style={{ flex: 1 }}>
                          <h3
                            style={{
                              margin: 0,
                              fontSize: "13px",
                              fontWeight: "800",
                            }}
                          >
                            Shipping Address
                          </h3>
                          <p
                            style={{
                              margin: "8px 0 0 0",
                              fontSize: "12px",
                              lineHeight: "18px",
                            }}
                          >
                            {orderDetails.address},{orderDetails.city}
                            <br />
                            {orderDetails.state},{orderDetails.country}-
                            {orderDetails.used_pincode}
                            <br />
                            Contact No: {orderDetails.mobile_no}
                          </p>
                        </div>
                      </div>

                      <hr
                        style={{
                          margin: "14px 0",
                          border: "0.5px solid #e5e7eb",
                        }}
                      />

                      {/* ORDER SUMMARY */}
                      <h3
                        style={{
                          margin: "0 0 10px 0",
                          fontSize: "13px",
                          fontWeight: "900",
                        }}
                      >
                        Order Summary
                      </h3>

                      <table
                        style={{
                          width: "100%",
                          borderCollapse: "collapse",
                          fontSize: "12px",
                          tableLayout: "fixed",
                        }}
                      >
                        <thead>
                          <tr style={{ backgroundColor: "#f3f4f6" }}>
                            <th style={thCenterStyle}>S.No</th>
                            <th style={thStyle}>Item</th>
                            <th style={thRightStyle}>Rate</th>
                            <th style={thCenterStyle}>Qty</th>
                            {showTaxColumn && <th style={thRightStyle}>Price</th>}

                            {showTaxColumn && <th style={thRightStyle}>Tax Amount</th>}
                            {showTaxColumn && <th style={thCenterStyle}>Tax %</th>}


                            <th style={thRightStyle}>Amount</th>
                          </tr>
                        </thead>



                        <tbody>
                          {orderDetails.product_details?.map((item, idx) => {
                            const qty = toNumber(item.quantity);
                            const taxPercent = toNumber(item.tax_percentage);

                            // Backend final price (ASSUME GST INCLUDED ALWAYS)
                            const backendRate = toNumber(item.product_final_price);

                            const unitRateWithTax = backendRate / qty;

                            // remove GST from UNIT price
                            let rateWithoutTax = unitRateWithTax;

                            if (taxPercent > 0) {
                              rateWithoutTax = unitRateWithTax / (1 + taxPercent / 100);
                            }

                            // Price WITHOUT GST
                            const priceWithoutTax = rateWithoutTax * qty;

                            const gstAmount = backendRate - priceWithoutTax;


                            // Amount = backend total (KEEP AS IS)
                            const finalAmount = backendRate;

                            return (
                              <tr key={idx}>
                                <td style={tdCenterStyle}>{idx + 1}</td>

                                <td style={tdStyle}>{item.product_name}</td>

                                {/* Rate WITHOUT GST */}
                                <td style={tdRightStyle}>₹ {rateWithoutTax.toFixed(2)}</td>

                                <td style={tdCenterStyle}>{qty}</td>

                                {/* Price WITHOUT GST */}
                                {item.including_tax === "No" && (
                                  <td style={tdRightStyle}>₹ {priceWithoutTax.toFixed(2)}</td>
                                )}

                                {/* Tax columns ONLY when including_tax = No */}
                                {item.including_tax === "No" && (
                                  <td style={tdRightStyle}>₹ {gstAmount.toFixed(2)}</td>
                                )}

                                {item.including_tax === "No" && (
                                  <td style={tdCenterStyle}>
                                    {taxPercent > 0 ? `${taxPercent}%` : "-"}
                                  </td>
                                )}

                                {/* Amount WITH GST (unchanged backend) */}
                                <td style={tdRightStyle}>₹ {finalAmount.toFixed(2)}</td>
                              </tr>
                            );
                          })}
                        </tbody>






                      </table>

                      {/* CHARGES */}
                      <div
                        style={{
                          marginTop: "16px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <div style={{ width: "280px", fontSize: "12px" }}>
                          {toNumber(orderDetails.handling_fee) > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <span>Handling Charges</span>
                              <span>
                                ₹ {toNumber(orderDetails.handling_fee).toFixed(2)}
                              </span>
                            </div>
                          )}

                          {toNumber(orderDetails.rain_surge_charge) > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <span>Rain Surge Charges</span>
                              <span>
                                ₹{" "}
                                {toNumber(orderDetails.rain_surge_charge).toFixed(
                                  2
                                )}
                              </span>
                            </div>
                          )}

                          {toNumber(orderDetails.giftwrap_fee) > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <span>Gift Wrap Charges</span>
                              <span>
                                ₹ {toNumber(orderDetails.giftwrap_fee).toFixed(2)}
                              </span>
                            </div>
                          )}

                          {toNumber(orderDetails.tip_amount) > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <span>Tip Amount</span>
                              <span>
                                ₹ {toNumber(orderDetails.tip_amount).toFixed(2)}
                              </span>
                            </div>
                          )}

                          {toNumber(orderDetails.donation_fee) > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <span>Donation Amount</span>
                              <span>
                                ₹ {toNumber(orderDetails.donation_fee).toFixed(2)}
                              </span>
                            </div>
                          )}

                          {toNumber(orderDetails.delivery_slot_price) > 0 && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px",
                              }}
                            >
                              <span>Delivery Slot Price</span>
                              <span>
                                ₹{" "}
                                {toNumber(orderDetails.delivery_slot_price).toFixed(
                                  2
                                )}
                              </span>
                            </div>
                          )}

                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                              paddingTop: "10px",
                              borderTop: "1px solid #e5e7eb",
                              fontWeight: "900",
                              fontSize: "13px",
                            }}
                          >
                            <span>Total Amount</span>
                            <span>
                              ₹{" "}
                              {toNumber(orderDetails.total_paid_price).toFixed(2)}
                            </span>
                          </div>
                        </div>
                      </div>

                      <p
                        style={{
                          marginTop: "18px",
                          fontSize: "11px",
                          color: "#6b7280",
                        }}
                      >
                        This is a system generated invoice. No signature required.
                      </p>
                    </div>
                  </div>
                </>
              )}

              {/* Rate Modal Part kept as it is */}
              {showRateModal && showRateModal.order_id === order.order_id && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                  <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-lg">
                    <h3 className="mb-4 text-xl font-semibold text-gray-800">
                      Rate Order {showRateModal.order_id}
                    </h3>
                    <div className="mb-4">
                      <label className="block mb-2 font-medium text-gray-700">
                        Rating
                      </label>
                      <div className="flex gap-1">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <button
                            key={star}
                            onClick={() => setRating(star)}
                            className="text-2xl transition-colors duration-200 hover:text-yellow-300 focus:outline-none"
                          >
                            <RiStarSLine
                              className={
                                star <= rating
                                  ? "text-yellow-400"
                                  : "text-gray-300"
                              }
                            />
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="mb-4">
                      <label className="block mb-2 font-medium text-gray-700">
                        Review
                      </label>
                      <select
                        value={reviewReason}
                        onChange={(e) => setReviewReason(e.target.value)}
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="">Select a reason</option>
                        <option value="Great product quality">
                          Great product quality
                        </option>
                        <option value="Fast delivery">Fast delivery</option>
                        <option value="Excellent customer service">
                          Excellent customer service
                        </option>
                        <option value="Product as described">
                          Product as described
                        </option>
                        <option value="Good value for money">
                          Good value for money
                        </option>
                        <option value="Poor product quality">
                          Poor product quality
                        </option>
                        <option value="Slow delivery">Slow delivery</option>
                        <option value="Issue with product fit">
                          Issue with product fit
                        </option>
                        <option value="Damaged product received">
                          Damaged product received
                        </option>
                        <option value="Incorrect item delivered">
                          Incorrect item delivered
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    {reviewReason === "Other" && (
                      <div className="mb-4">
                        <label className="block mb-2 font-medium text-gray-700">
                          Custom Reason
                        </label>
                        <textarea
                          value={customReason}
                          onChange={(e) => setCustomReason(e.target.value)}
                          placeholder="Type your reason here..."
                          className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                          rows="3"
                        ></textarea>
                      </div>
                    )}

                    <div className="mb-4">
                      <label className="block mb-2 font-medium text-gray-700">
                        Upload Image (Optional)
                      </label>
                      <input
                        id="review-image-input"
                        type="file"
                        accept="image/jpeg,image/jpg,image/png"
                        onChange={handleImageChange}
                        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      {imagePreview && (
                        <div className="mt-2">
                          <img
                            src={imagePreview}
                            alt="Review preview"
                            className="object-cover w-32 h-32 border border-gray-200 rounded-md"
                          />
                          <button
                            onClick={handleRemoveImage}
                            className="mt-2 text-sm text-red-500 hover:text-red-600"
                          >
                            Remove Image
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="flex justify-end gap-2">
                      <button
                        onClick={() => setShowRateModal(null)}
                        className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={() =>
                          handleSubmitRating(
                            showRateModal.order_id,
                            showRateModal.product_auto_id,
                            showRateModal.product_order_auto_id
                          )
                        }
                        className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700"
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))
        )}
      </div>

      <div className="flex flex-wrap items-center justify-center gap-2 mt-6 text-sm">
        <button
          onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
          disabled={page === 1}
          className={`px-4 py-2 rounded-md border transition-all ${page === 1
            ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
            : "text-blue-600 bg-white border-blue-300 hover:bg-blue-50"
            }`}
        >
          Previous
        </button>

        {Array.from({ length: totalPages }).map((_, index) => {
          const pageNumber = index + 1;
          const shouldRender =
            pageNumber === 1 ||
            pageNumber === totalPages ||
            (pageNumber >= page - 1 && pageNumber <= page + 1);

          if (!shouldRender && pageNumber === page - 1) return null;

          if (shouldRender) {
            return (
              <button
                key={pageNumber}
                onClick={() => setPage(pageNumber)}
                className={`px-3 py-1.5 rounded-md border transition-all ${pageNumber === page
                  ? "bg-blue-600 text-white border-blue-700"
                  : "bg-white text-blue-600 border-blue-300 hover:bg-blue-50"
                  }`}
              >
                {pageNumber}
              </button>
            );
          }

          if (
            (pageNumber === 2 && page > 3) ||
            (pageNumber === totalPages - 1 && page < totalPages - 2)
          ) {
            return (
              <span key={pageNumber} className="px-2 text-gray-400">
                ...
              </span>
            );
          }
          return null;
        })}

        <button
          onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
          disabled={page === totalPages}
          className={`px-4 py-2 rounded-md border transition-all ${page === totalPages
            ? "text-gray-400 bg-gray-100 border-gray-200 cursor-not-allowed"
            : "text-blue-600 bg-white border-blue-300 hover:bg-blue-50"
            }`}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default MyOrders;
